import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchCommentsApi } from '@Src/apiServices/ticketingService';
import {
  initialCommentsState,
  TicketingApiResponseStatus,
} from '@Src/store/types';
import { RootState } from '@Src/store';
import { apiLoading, apiRejected } from '@Src/store/reducers/Ticketing/helpers';

export const fetchComments = createAsyncThunk(
  'fetchComments',
  async (fetchCommentsApiRequest: any) => {
    const { ticketId, appSource } = fetchCommentsApiRequest;
    // ticket_id
    const params = new Map<string, string>();
    params.set('ticket_id', ticketId.toString());
    return fetchCommentsApi(Object.fromEntries(params), appSource);
  }
);

export const commentsSlice = createSlice({
  name: 'commentsSlice',
  initialState: initialCommentsState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchComments.pending, apiLoading)
      .addCase(fetchComments.rejected, apiRejected)
      .addCase(fetchComments.fulfilled, (state, action) => {
        state.comments = ((Conversation) => Conversation)(action.payload);
        state.status = TicketingApiResponseStatus.succeeded;
      });
  },
});

export const getComments = (store: RootState) => store.commentsReducer.comments;
export const getCommentsStatus = (store: RootState) =>
  store.commentsReducer.status;

export default commentsSlice.reducer;
